const getters = {
  token: state => state.token,
  name: state => state.name,
  role: state => state.role,
  permissions: state => state.permissions,
  storeid: state => state.storeid,
  utop: state => state.utop,
  lang: state => state.lang,
  langId: state => state.langId
  // tax: state => state.businessSetting.tax,
  // taxType: state => state.businessSetting.taxType,
  // settings: state => state.businessSetting.settings,

}
export default getters
